
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/releases/20241023/ui/shared/outcomes/jst/-calculationMethodExample';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <dt class=\"example\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.calculation_method_example")
  },data:data},helper ? helper.call(depth0, "warning_aacb8c24", "Warning", options) : helperMissing.call(depth0, "t", "warning_aacb8c24", "Warning", options)))
    + ": </dt>\n  <dd class=\"example\">";
  if (helper = helpers.exampleWarning) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.exampleWarning); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</dd>\n  ";
  return buffer;
  }

  buffer += "<dl class=\"dl-horizontal\">\n  <dt>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.calculation_method_example")
  },data:data},helper ? helper.call(depth0, "calculation_method_fe281f9", "Calculation Method", options) : helperMissing.call(depth0, "t", "calculation_method_fe281f9", "Calculation Method", options)))
    + ":</dt>\n  <dd>";
  if (helper = helpers.method) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.method); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</dd>\n\n  <dt class=\"example\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.calculation_method_example")
  },data:data},helper ? helper.call(depth0, "example_84698b7d", "Example", options) : helperMissing.call(depth0, "t", "example_84698b7d", "Example", options)))
    + ": </dt>\n  <dd id=\"calculation_int_example\" class=\"example\">";
  if (helper = helpers.exampleText) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.exampleText); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</dd>\n  \n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.exampleWarning), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  <dt class=\"example\">\n    <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.calculation_method_example")
  },data:data},helper ? helper.call(depth0, "1_item_scores_5512cd03", "1- Item scores", options) : helperMissing.call(depth0, "t", "1_item_scores_5512cd03", "1- Item scores", options)))
    + ": </span>\n    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.calculation_method_example")
  },data:data},helper ? helper.call(depth0, "example_item_scores_6726c689", "Example item scores", options) : helperMissing.call(depth0, "t", "example_item_scores_6726c689", "Example item scores", options)))
    + ": </span>\n  </dt>\n  <dd class=\"example\">";
  if (helper = helpers.exampleScores) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.exampleScores); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</dd>\n\n  <dt class=\"example\">\n    <span aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.calculation_method_example")
  },data:data},helper ? helper.call(depth0, "2_final_score_7b0fd15e", "2- Final score", options) : helperMissing.call(depth0, "t", "2_final_score_7b0fd15e", "2- Final score", options)))
    + ": </span>\n    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.calculation_method_example")
  },data:data},helper ? helper.call(depth0, "example_final_score_355aff0f", "Example final score", options) : helperMissing.call(depth0, "t", "example_final_score_355aff0f", "Example final score", options)))
    + "</span>\n  </dt>\n  <dd class=\"example\">"
    + escapeExpression((helper = helpers.nf || (depth0 && depth0.nf),options={hash:{
    'format': ("outcomeScore")
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.exampleResult), options) : helperMissing.call(depth0, "nf", (depth0 && depth0.exampleResult), options)))
    + "</dd>\n</dl>\n";
  return buffer;
  });
    
      Handlebars.registerPartial('ui/shared/outcomes/jst/_calculationMethodExample.handlebars', templates['/var/canvas/releases/20241023/ui/shared/outcomes/jst/-calculationMethodExample']);
    ;
    ;
    export default templates[name];
  